import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dbe1a96"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "ion-text-center" }
const _hoisted_5 = { class: "ion-text-center" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "ion-text-center" }
const _hoisted_10 = { class: "ion-text-center" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "ion-text-center" }
const _hoisted_16 = { class: "ion-text-center" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "actions" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_20 = {
  key: 3,
  class: "desktop-only"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Filters = _resolveComponent("Filters")!
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_JobConfiguration = _resolveComponent("JobConfiguration")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_Filters, {
        "content-id": "filter-content",
        segmentSelected: _ctx.segmentSelected,
        queryString: _ctx.queryString
      }, null, 8, ["segmentSelected", "queryString"]),
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_menu_button, { slot: "start" }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("Pipeline")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { menu: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.filterOutline,
                        color: _ctx.filterIconColor
                      }, null, 8, ["icon", "color"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createVNode(_component_ion_searchbar, {
              placeholder: _ctx.translate('Search jobs'),
              onIonClear: _cache[0] || (_cache[0] = ($event: any) => {_ctx.queryString = ''; _ctx.segmentSelected === 'pending' ? _ctx.getPendingJobs() : ( _ctx.segmentSelected === 'running' ? _ctx.getRunningJobs() : _ctx.getJobHistory())}),
              modelValue: _ctx.queryString,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryString) = $event)),
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => {_ctx.queryString = $event.target.value; _ctx.segmentSelected === 'pending' ? _ctx.getPendingJobs() : ( _ctx.segmentSelected === 'running' ? _ctx.getRunningJobs() : _ctx.getJobHistory())}, ["enter"]))
            }, null, 8, ["placeholder", "modelValue"]),
            _createVNode(_component_ion_segment, {
              modelValue: _ctx.segmentSelected,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.segmentSelected) = $event)),
              onIonChange: _ctx.segmentChanged
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, { value: "pending" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Pending")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "running" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Running")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "history" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("History")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onIonChange"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        ref: "contentRef",
        id: "filter-content"
      }, {
        default: _withCtx(() => [
          (_ctx.jobsLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_item, { lines: "none" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_spinner, {
                      name: "crescent",
                      slot: "start"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate("Fetching jobs")), 1)
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("main", _hoisted_2, [
                (_ctx.segmentSelected === 'pending')
                  ? (_openBlock(), _createElementBlock("section", {
                      key: 0,
                      class: "ion-content-scroll-host",
                      "scroll-events": true,
                      onScroll: _cache[7] || (_cache[7] = ($event: any) => (_ctx.enableScrolling()))
                    }, [
                      (_ctx.pendingJobs?.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.translate("There are no jobs pending right now")), 1),
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_ion_button, {
                                fill: "outline",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refreshJobs(undefined, true)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate('retry')) + " ", 1),
                                  (_ctx.isRetrying)
                                    ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                        key: 0,
                                        name: "crescent"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingJobs, (job) => {
                              return (_openBlock(), _createBlock(_component_ion_card, {
                                key: job.jobId,
                                onClick: ($event: any) => (_ctx.viewJobConfiguration(job)),
                                button: _ctx.isDesktop,
                                class: _normalizeClass({ 'selected-job': _ctx.selectedJobId === job.jobId })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_header, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.enumName), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (job.runTime)
                                        ? (_openBlock(), _createBlock(_component_ion_badge, {
                                            key: 0,
                                            color: "dark"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.timeFromNow(job.runTime)), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("p", null, _toDisplayString(job.description), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.timeOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.runTime ? _ctx.getTime(job.runTime) : "-"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.timerOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.tempExprId ? _ctx.temporalExpr(job.tempExprId)?.description : "🙃"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.refreshOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.currentRetryCount), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, { lines: "full" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.codeWorkingOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.systemJobEnumId), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ion_icon, {
                                        icon: _ctx.helpCircleOutline,
                                        onClick: _withModifiers(($event: any) => (_ctx.openLearnMoreModal(job)), ["stop","prevent"])
                                      }, null, 8, ["icon", "onClick"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_ion_button, {
                                        disabled: !_ctx.hasPermission(_ctx.Actions.APP_JOB_UPDATE),
                                        fill: "clear",
                                        onClick: _withModifiers(($event: any) => (_ctx.skipJob(job)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.translate("Skip")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["disabled", "onClick"]),
                                      _createVNode(_component_ion_button, {
                                        disabled: !_ctx.hasPermission(_ctx.Actions.APP_JOB_UPDATE),
                                        color: "danger",
                                        fill: "clear",
                                        onClick: _withModifiers(($event: any) => (_ctx.cancelJob(job)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.translate("Cancel")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["disabled", "onClick"])
                                    ]),
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_ion_button, {
                                        fill: "clear",
                                        color: "medium",
                                        slot: "end",
                                        onClick: _withModifiers(($event: any) => (_ctx.openJobActions(job, $event)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "icon-only",
                                            icon: _ctx.ellipsisVerticalOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick", "button", "class"]))
                            }), 128)),
                            _createVNode(_component_ion_refresher, {
                              slot: "fixed",
                              onIonRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.refreshJobs($event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_refresher_content, {
                                  pullingIcon: "crescent",
                                  refreshingSpinner: "crescent"
                                })
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_ion_infinite_scroll, {
                              onIonInfinite: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMorePendingJobs($event))),
                              threshold: "300px",
                              ref: "infiniteScrollRef"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_infinite_scroll_content, {
                                  "loading-spinner": "crescent",
                                  "loading-text": _ctx.translate('Loading')
                                }, null, 8, ["loading-text"])
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.isPendingJobsScrollable]
                            ])
                          ]))
                    ], 32))
                  : _createCommentVNode("", true),
                (_ctx.segmentSelected === 'running')
                  ? (_openBlock(), _createElementBlock("section", {
                      key: 1,
                      class: "ion-content-scroll-host",
                      "scroll-events": true,
                      onScroll: _cache[11] || (_cache[11] = ($event: any) => (_ctx.enableScrolling()))
                    }, [
                      (_ctx.runningJobs?.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.translate("There are no jobs running right now")), 1),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_ion_button, {
                                fill: "outline",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.refreshJobs(undefined, true)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate('retry')) + " ", 1),
                                  (_ctx.isRetrying)
                                    ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                        key: 0,
                                        slot: "end",
                                        name: "crescent"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.runningJobs, (job) => {
                              return (_openBlock(), _createBlock(_component_ion_card, {
                                key: job.jobId
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_header, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_ion_card_subtitle, { class: "overline" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(job.parentJobId), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_ion_card_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(job.enumName), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createVNode(_component_ion_badge, { color: "dark" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.statusDesc), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("p", null, _toDisplayString(job.description), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.timeOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.runTime ? _ctx.getTime(job.runTime) : "-"), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (job.startDateTime)
                                        ? (_openBlock(), _createBlock(_component_ion_note, {
                                            key: 0,
                                            slot: "end"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.translate('Started')) + " " + _toDisplayString(_ctx.timeFromNow(job.startDateTime)), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (_openBlock(), _createBlock(_component_ion_note, {
                                            key: 1,
                                            slot: "end"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("-")
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.timerOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.tempExprId ? _ctx.temporalExpr(job.tempExprId)?.description : "🙃"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, { lines: "full" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.codeWorkingOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.serviceName), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("div", _hoisted_12, [
                                    _hoisted_13,
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_ion_button, {
                                        fill: "clear",
                                        color: "medium",
                                        onClick: _withModifiers(($event: any) => (_ctx.copyJobInformation(job)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "icon-only",
                                            icon: _ctx.copyOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_ion_button, {
                                        fill: "clear",
                                        color: "medium",
                                        onClick: _withModifiers(($event: any) => (_ctx.viewJobHistory(job)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "icon-only",
                                            icon: _ctx.timeOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128)),
                            _createVNode(_component_ion_refresher, {
                              slot: "fixed",
                              onIonRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.refreshJobs($event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_refresher_content, {
                                  pullingIcon: "crescent",
                                  refreshingSpinner: "crescent"
                                })
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_ion_infinite_scroll, {
                              onIonInfinite: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadMoreRunningJobs($event))),
                              threshold: "300px",
                              ref: "infiniteScrollRef"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_infinite_scroll_content, {
                                  "loading-spinner": "crescent",
                                  "loading-text": _ctx.translate('Loading')
                                }, null, 8, ["loading-text"])
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.isRunningJobsScrollable]
                            ])
                          ]))
                    ], 32))
                  : _createCommentVNode("", true),
                (_ctx.segmentSelected === 'history')
                  ? (_openBlock(), _createElementBlock("section", {
                      key: 2,
                      class: "ion-content-scroll-host",
                      "scroll-events": true,
                      onScroll: _cache[15] || (_cache[15] = ($event: any) => (_ctx.enableScrolling()))
                    }, [
                      (_ctx.jobHistory?.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.translate("No jobs have run yet")), 1),
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_ion_button, {
                                fill: "outline",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.refreshJobs(undefined, true)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate('retry')) + " ", 1),
                                  (_ctx.isRetrying)
                                    ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                        key: 0,
                                        name: "crescent"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobHistory, (job) => {
                              return (_openBlock(), _createBlock(_component_ion_card, {
                                key: job.jobId,
                                onClick: ($event: any) => (_ctx.viewJobConfiguration(job)),
                                button: _ctx.isDesktop,
                                class: _normalizeClass({ 'selected-job': _ctx.selectedJobId === job.jobId })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_header, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_ion_card_subtitle, { class: "overline" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(job.parentJobId), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_ion_card_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(job.enumName), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createElementVNode("div", null, [
                                        (job.cancelDateTime || job.finishDateTime)
                                          ? (_openBlock(), _createBlock(_component_ion_badge, {
                                              key: 0,
                                              color: "dark"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(job.statusId == "SERVICE_CANCELLED" || job.statusId == "SERVICE_CRASHED" ?  _ctx.timeFromNow(job.cancelDateTime) : _ctx.timeFromNow(job.finishDateTime)), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true),
                                        (job.statusId)
                                          ? (_openBlock(), _createBlock(_component_ion_badge, {
                                              key: 1,
                                              color: job.statusId === 'SERVICE_FINISHED' ? 'success' : 'danger',
                                              onClick: _withModifiers(($event: any) => (job.statusId === 'SERVICE_FAILED' ? _ctx.openFailedJobReason(job) : ''), ["stop"])
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(job.statusDesc), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["color", "onClick"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("p", null, _toDisplayString(job.description), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.personOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.translate("Created by", { userLogin: job.createdByUserLogin })), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ion_label, { slot: "end" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.createdDate ? _ctx.getDateTime(job.createdDate) : "-"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.peopleOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.translate("Updated by", { userLogin: job.lastModifiedByUserLogin })), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ion_label, { slot: "end" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.lastUpdatedStamp ?  _ctx.getDateTime(job.lastUpdatedStamp) : "-"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.timeOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.runTime ? _ctx.getTime(job.runTime) : "-") + " ", 1),
                                          _createElementVNode("p", null, _toDisplayString(job.recurrenceTimeZone), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ion_note, { slot: "end" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.statusId == "SERVICE_CANCELLED" || job.statusId == "SERVICE_CRASHED" ? _ctx.getJobExecutionTime(job.startDateTime, job.cancelDateTime) : _ctx.getJobExecutionTime(job.startDateTime, job.finishDateTime)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.timerOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.tempExprId ? _ctx.temporalExpr(job.tempExprId)?.description : "🙃"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item, { lines: "full" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.codeWorkingOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.serviceName), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("div", _hoisted_18, [
                                    _hoisted_19,
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_ion_button, {
                                        fill: "clear",
                                        color: "medium",
                                        onClick: _withModifiers(($event: any) => (_ctx.copyJobInformation(job)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "icon-only",
                                            icon: _ctx.copyOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_ion_button, {
                                        fill: "clear",
                                        color: "medium",
                                        onClick: _withModifiers(($event: any) => (_ctx.viewJobHistory(job)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "icon-only",
                                            icon: _ctx.timeOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick", "button", "class"]))
                            }), 128)),
                            _createVNode(_component_ion_refresher, {
                              slot: "fixed",
                              onIonRefresh: _cache[13] || (_cache[13] = ($event: any) => (_ctx.refreshJobs($event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_refresher_content, {
                                  pullingIcon: "crescent",
                                  refreshingSpinner: "crescent"
                                })
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_ion_infinite_scroll, {
                              onIonInfinite: _cache[14] || (_cache[14] = ($event: any) => (_ctx.loadMoreJobHistory($event))),
                              threshold: "300px",
                              ref: "infiniteScrollRef"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_infinite_scroll_content, {
                                  "loading-spinner": "crescent",
                                  "loading-text": _ctx.translate('Loading')
                                }, null, 8, ["loading-text"])
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.isHistoryJobsScrollable]
                            ])
                          ]))
                    ], 32))
                  : _createCommentVNode("", true),
                (_ctx.isDesktop)
                  ? _withDirectives((_openBlock(), _createElementBlock("aside", _hoisted_20, [
                      (_openBlock(), _createBlock(_component_JobConfiguration, {
                        status: _ctx.currentJobStatus,
                        type: _ctx.freqType,
                        historyJobConfig: _ctx.segmentSelected === 'history',
                        key: _ctx.currentJob
                      }, null, 8, ["status", "type", "historyJobConfig"]))
                    ], 512)), [
                      [_vShow, (_ctx.segmentSelected === 'pending' || _ctx.segmentSelected === 'history') && _ctx.currentJob && Object.keys(_ctx.currentJob).length]
                    ])
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      }, 512),
      (_ctx.getPinnedJobs && _ctx.getPinnedJobs.length)
        ? (_openBlock(), _createBlock(_component_ion_footer, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, {
                    slot: "start",
                    class: "desktop-only"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.translate("Pinned jobs")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_icon, {
                    slot: "start",
                    class: "mobile-only",
                    icon: _ctx.pinOutline
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPinnedJobs, (job, index) => {
                      return (_openBlock(), _createBlock(_component_ion_chip, {
                        key: index,
                        onClick: ($event: any) => (_ctx.updateSelectedPinnedJob(job)),
                        outline: !_ctx.isPinnedJobSelected(job)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getEnumName(job)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_icon, {
                            onClick: _withModifiers(($event: any) => (_ctx.updatePinnedJobs(job)), ["stop"]),
                            icon: _ctx.closeCircleOutline
                          }, null, 8, ["onClick", "icon"])
                        ]),
                        _: 2
                      }, 1032, ["onClick", "outline"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}